import Cookies from "js-cookie";
import { Permission } from "types/role";

const TOKEN_KEY = "token";

export const getToken = () => {
  const token = Cookies.get(TOKEN_KEY);

  return token || "";
};

export const setToken = (token: string) => {
  return Cookies.set(TOKEN_KEY, token);
};

export const checkRole = (role: string, permissions?: Permission[]) => {
  const find = permissions?.find((e) => e.path.includes(role));
  if (find) return true;
  return false;
};
